@if (isLoading()) {
  <app-page-loader />
} @else {
  <div class="min-h-screen flex bg-shikenso-base-white">
    <div class="flex-[0.5] flex flex-col items-center mx-auto my-auto">
      <div class="flex w-full items-center justify-center mb-12">
        <img src="images/logo/logo.png" alt="Logo" width="36" />
      </div>
      <div class="bg-shikenso-gray-base px-14 py-10 rounded-2xl max-w-[440px]">
        <div class="flex flex-col items-center justify-center gap-2 mb-6 px-6">
          <h1 class="text-[28px] font-bold text-black">{{ 'pages.login.welcomeBack' | translate }}</h1>
          <p class="text-shikenso-gray-700 text-sm text-center">{{ 'pages.login.enterYourCredentials' | translate }}</p>
        </div>

        @if (afterPasswordForgot() || afterPasswordReset()) {
          <div class="flex items-center justify-center mb-6 p-3 gap-2 rounded-2xl bg-shikenso-success-light">
            <app-icon src="/icons/check.svg" alt="Checkmark" color="var(--shikenso-success-base)" />
            <p class="text-shikenso-success-base text-sm">
              {{
                afterPasswordForgot()
                  ? ('pages.login.afterPasswordForgotMessage' | translate)
                  : ('pages.login.afterPasswordResetMessage' | translate)
              }}
            </p>
          </div>
        }

        <div class="flex flex-col items-center gap-2">
          <div class="social-login-button" (click)="onGoogleLogin()">
            <div class="flex items-center gap-2">
              <img src="/icons/login/google.svg" alt="Google" width="16" height="16" />
              {{ 'pages.login.continueWithGoogle' | translate }}
            </div>
          </div>
          <!-- NOTE: Facebook and Twitter login require developer accounts -->
          <!-- <button
            mat-stroked-button
            (click)="onFacebookLogin()"
            class="w-full flex items-center justify-center gap-3 h-12 rounded-lg font-medium"
          >
            <div class="flex items-center gap-2">
              <app-icon src="/icons/login/facebook.svg" alt="Facebook" width="16" height="16" />
              {{ 'pages.login.continueWithFacebook' | translate }}
            </div>
          </button>
          <button
            mat-stroked-button
            (click)="onTwitterLogin()"
            class="w-full flex items-center justify-center gap-3 h-12 rounded-lg font-medium"
          >
            <div class="flex items-center gap-2">
              <app-icon src="/icons/login/x.svg" alt="X" width="16" height="16" />
              {{ 'pages.login.continueWithX' | translate }}
            </div>
          </button> -->
        </div>

        <div class="relative text-center my-6">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-black opacity-20"></div>
          </div>
          <span class="relative bg-shikenso-gray-base">
            <span class="px-3 text-shikenso-purple-base opacity-50 text-xs align-[1px]">
              {{ 'pages.login.or' | translate }}
            </span>
          </span>
        </div>

        <form class="flex flex-col gap-2 custom-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <mat-form-field class="w-full">
            <input
              matInput
              type="email"
              formControlName="email"
              [placeholder]="'pages.login.email' | translate"
              data-testid="login-email"
            />
            @if (loginForm.get('email')?.hasError('required')) {
              <mat-error>
                {{ 'pages.login.emailRequired' | translate }}
              </mat-error>
            }

            @if (loginForm.get('email')?.hasError('email')) {
              <mat-error>
                {{ 'pages.login.emailInvalid' | translate }}
              </mat-error>
            }
          </mat-form-field>

          @if (!isEmailStep()) {
            <mat-form-field class="w-full">
              <input
                matInput
                [type]="showPassword() ? 'text' : 'password'"
                formControlName="password"
                [placeholder]="'pages.login.password' | translate"
                data-testid="login-password"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="!bg-transparent mat-big-icon-button"
                (click)="togglePasswordVisibility()"
              >
                @if (showPassword()) {
                  <app-icon src="/icons/view-off.svg" alt="View off" [size]="24" />
                } @else {
                  <app-icon src="/icons/view.svg" alt="View" [size]="24" />
                }
              </button>
              @if (loginForm.get('password')?.hasError('required')) {
                <mat-error>
                  {{ 'pages.login.passwordRequired' | translate }}
                </mat-error>
              }
            </mat-form-field>
          }

          <button
            mat-flat-button
            color="primary"
            [type]="isEmailStep() ? 'button' : 'submit'"
            (click)="isEmailStep() ? onContinue() : null"
            [attr.data-testid]="isEmailStep() ? 'login-continue-button' : 'login-submit-button'"
          >
            {{ isEmailStep() ? ('pages.login.continue' | translate) : ('pages.login.signIn' | translate) }}
          </button>

          <button mat-flat-button type="button" color="secondary-transparent" (click)="onForgotPassword()">
            {{ 'pages.login.forgotPassword' | translate }}
          </button>
        </form>
      </div>
    </div>

    <div class="flex-[0.5] login-image">
      <div class="w-full h-full flex items-end justify-center pb-16"></div>
    </div>
  </div>
}
